import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { setTimeout } from 'timers';
//import { AuthorizationService } from './services/authorization-service/authorization.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private router: Router, private toaster: ToastrService) { }

  private addExtraHeaders(headers: HttpHeaders): HttpHeaders {
    
    headers = headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('username'));
    // headers.append("Content-Type", "application/json");
    // headers.append('Access-Control-Allow-Credentials', 'true');
    // headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
    // headers.append('Accept', 'application/json');
    return headers;
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: this.addExtraHeaders(request.headers)
    });
    return next.handle(request).pipe(
      catchError(err => {
       
        switch (err.status) {
          case 500:
            break;
          case 401:
            if (err.error) {
              if (err.error.message == 'valid_auth_token_required') {
                window.location.href = window.location.protocol+"/unauthorized";
              }
            }
            break;
            case 400:
              if (err.error) {
                throwError(err.error)
              }
              break;
        }
        return throwError(err);
      })
    );
  }
}
